'use client';

import Script from 'next/script';

interface RecaptchaEnterpriseScriptProps {
  siteKey: string;
  nonce?: string;
}

/** Form/route-level loader only. Do not mount from the root layout. */
export function RecaptchaEnterpriseScript({ siteKey, nonce }: RecaptchaEnterpriseScriptProps) {
  const src = `https://www.google.com/recaptcha/enterprise.js?render=${encodeURIComponent(siteKey)}`;

  return <Script id='recaptcha-enterprise' src={src} strategy='lazyOnload' nonce={nonce} />;
}
